$(document).ready(function () {
var checkGlobo = setInterval(function() {
    if ($('.ul-swatches-list').length) {
        $(".product-item.globo-swatch-product-item").each(function() {
            var titleName = $(this).find('.product-information').data('title');
            if (titleName) {
                var inputLabel = $(this).find('.ul-swatches-list li input[value="'+titleName+'"] + label');
                if (inputLabel.length) {
                    var scrollPos = $(window).scrollTop();
                    
                    inputLabel[0].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });

                    inputLabel[0].click();

                    $(window).scrollTop(scrollPos);
                }
            }
        });
        clearInterval(checkGlobo);
    }
}, 100);


  setInterval(function () {
      $(".js-product").each(function () {
        if($(this).find(".name-variant").eq(0).length > 0) {
          if($(this).find(".name-variant").eq(0).html() != '') {
            // var name = $(this).find(".name-variant").eq(0).html().replace(':', '');
            // $(this).find(".js-team-name").html(name);
            var variantId = $(this).find("select[name='idGlobo']").val();
            var newUrl = $(this).attr("data-url") + "?variant=" + variantId;
            $(this).find("a").attr("href", newUrl);
          }
        }
      });
  }, 100);
  setTimeout(function () {
    if($(".js-main-product").length > 0) {
      if($(".js-main-product").attr("data-variant-title") != '') {
        var variantTitle = $(".js-main-product").attr("data-variant-title");
        $("li[data-value='" + variantTitle + "'] label").eq(0).click().trigger("click"); 
      }
    }
  }, 1200);
  setTimeout(function () {
    if($(".js-main-product").length > 0) {
      if($(".js-main-product").attr("data-variant-title") != '') {
        var variantTitle = $(".js-main-product").attr("data-variant-title");
        $("li[data-value='" + variantTitle + "'] label").eq(0).click().trigger("click"); 
      }
    }
  }, 2400);
  setInterval(function () {
    if($(".js-main-product-title").length > 0) {
      if($(".js-main-product .name-variant").length > 0) {
        var name = $(".js-main-product .name-variant").eq(0).html().replace(':', '');
        if(name.length > 2) {
          $(".js-main-product-title").html(name);
        }
      }
    }
  }, 100);

  $(document).on('click','.swatches-options',function(){
    var teamName = $(this).find('input').val();
    $(this).parents('.globo-swatch-product-item').find('.js-team-name').text(teamName);
  });
});